import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, matchPath } from 'react-router';
import { NavLink } from 'react-router-dom';
import { fetchNotebook, fetchAuthor } from '../../actions';
import Collection from './collection';
import ReadingList from './reading-list';
import CollectionItem from './collection-item';
import { monthNameDDYYYY } from '../date';

class Notebook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refreshed: false,
      // i use default 0 instead of empty to avoid the problem
      personalNoteId: '0',
    };
  }

  componentDidMount() {
    this.props.fetchNotebook();
    this.props.fetchAuthor();
  }

  setPersonalNoteID = (pnID) => {
    this.setState({
      personalNoteId: pnID,
    });
  }

  rerenderParentCallback= () => {
    this.setState((prevState) => ({
      refreshed: !prevState.refreshed,
    }));
  }

  renderSavedLinks = () => {
    const onReadinglist = matchPath(this.props.location.pathname, {
      path: '*/readinglist',
    });
    if (!onReadinglist) {
      return (
        <div className="collection-clicked">
          <p className="tab-desc">Stories to revisit and write notes about</p>
          <Collection setPersonalNoteID={this.setPersonalNoteID} />
        </div>
      );
    } else {
      return (
        <div className="queue-clicked">
          <p className="tab-desc">Stories to read later</p>
          <ReadingList callback={this.rerenderParentCallback} />
        </div>
      );
    }
  }

  renderTabs = () => {
    const onReadinglist = matchPath(this.props.location.pathname, {
      path: '*/readinglist',
    });
    if (!onReadinglist) {
      return (
        <div className="tabs">
          <NavLink className="tab" to="/notebook">
            <button className="collection-tab-clicked" type="button">
              <p>Collection</p>
              <i className="fas fa-book" />
            </button>
          </NavLink>
          <NavLink className="tab" to="/notebook/readinglist">
            <button className="queue-tab" type="button">
              <p>Reading List</p>
              <i className="fas fa-glasses" />
            </button>
          </NavLink>
        </div>
      );
    } else {
      return (
        <div className="tabs">
          <NavLink className="tab" to="/notebook">
            <button className="collection-tab" type="button">
              <p>Collection</p>
              <i className="fas fa-book" />
            </button>
          </NavLink>
          <NavLink className="tab" to="/notebook/readinglist">
            <button className="queue-tab-clicked" type="button">
              <p>Reading List</p>
              <i className="fas fa-glasses" />
            </button>
          </NavLink>
        </div>
      );
    }
  }

  renderDate = () => {
    return monthNameDDYYYY(new Date());
  }

  setPersonalNoteID = (pnID) => {
    this.setState({
      personalNoteId: pnID,
    });
  }

  render() {
    return (
      <div className="notebook-container">
        <div className="notebook-page">
          <div className="notebook-page-content">
            <p id="notebook-header">{this.props?.author?.name}&apos;s Notebook</p>
            {this.renderTabs()}
            <div className="tabLine" />
            {this.renderSavedLinks()}
          </div>
        </div>
        <div className="notebook-page">
          <div className="notebook-page-content">
            <p id="notebook-header">{this.renderDate()}</p>
            <div className="tabs">
              <p className="notes">Notes</p>
            </div>
            <div className="tabLine" />
            <CollectionItem personalNoteId={this.state.personalNoteId} />
          </div>
        </div>
      </div>
    );
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state) => (
  {
    notebook: state.notebook.current,
    personalNotes: state.personalNotes.all,
    author: state.author.current,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
// export default withRouter(connect(mapStateToProps, { fetchChapters, fetchBook })(TableOfContents));

// export default withRouter(Notebook);
export default withRouter(connect(mapStateToProps, { fetchNotebook, fetchAuthor })(Notebook));
